import React from 'react';
import PropTypes from 'prop-types';
import {
  Pagination as AntPagination,
} from 'antd';
// import { discartNullValues } from 'utils/formatValues';

const Pagination = ({
  callback,
  page,
  setPage,
  count,
  disabled,
}) => (
  <>
    <br />
    <AntPagination
      onChange={(_page) => {
        setPage(_page);
        callback(_page);
      }}
      total={count}
      current={page}
      showSizeChanger={false}
      showQuickJumper={false}
      disabled={disabled}
    />
    <br />
  </>
);

Pagination.propTypes = {
  count: PropTypes.number,
  callback: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Pagination.defaultProps = {
  count: 0,
  disabled: false,
};

export default Pagination;
